import { ReactNode } from 'react';
import { AnuidadeProvider } from './anuidade';

interface Props {
  children: ReactNode;
}
export function AppProvider({ children }: Props) {
  return <AnuidadeProvider>{children}</AnuidadeProvider>;
}
